var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2c-.9 0-1.7.5-2.1 1.4L7.6 7.2l-4.1.6c-.9.2-1.6.8-1.9 1.7-.3.9 0 1.8.6 2.4l3 3-.7 4.3c-.1.9.2 1.8.9 2.3.4.3.9.5 1.4.5.4 0 .8-.1 1.1-.3l3.6-2 3.6 2c.3.2.7.3 1.1.3.5 0 1-.2 1.4-.5.7-.5 1.1-1.4.9-2.3l-.7-4.3 3-3c.6-.6.8-1.6.6-2.4-.3-.9-1-1.5-1.9-1.6l-4.1-.6-1.8-3.9c-.4-.9-1.2-1.4-2.1-1.4z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.9b87812510f697c1b68f7697df692ed4.svg";
export { ForwardRef as ReactComponent };